import React from "react";

function Resume() {
  return (
    <div>
      <h2>Research</h2>
      {/* <div>
        <p>
          <b>MATRIKS Trinity</b>
        </p>
        <i>
          UC Davis, Human/Robotics/Vehicle Integration & Performance (HRVIP) Lab
        </i>
        <p>
          A set of simulations for a NASA project researching the
          neuroscience behind astronaut EDL training on Mars expeditions.
        </p>
      </div> */}
      <br></br>
    </div>
  );
}

export default Resume;
